export default __webpack_public_path__ + "static/media/jim-morrison.afcd3550.jpg";